export class DriverEscPos {

    static readonly init = '\x1B' + '\x40';
    static readonly normalFont = '\x1B' + '\x4D';
    static readonly boldOn = '\x1B' + '\x45' + '\x0D';
    static readonly boldOff = '\x1B' + '\x45' + '\x0A';
    static readonly breakLine = '\x0A';
    static readonly cutePaper = '\x1B' + '\x69';

    static readonly centeredEmphasizedOn = '\x1B' + '\x61' + '\x31' + '\x1d' + '\x42' + '\x01' + '\x1B' + '\x21' + '\x30';
    static readonly centeredEmphasizedOff = '\x1B' + '\x21' + '\x0A' + '\x1B' + '\x45' + '\x0A' + '\x1d' + '\x42' + '\x00' + '\x0A' + '\x0A' + '\x1B' + '\x61' + '\x30';

    static generateBufferFromHTML(html: string): string {
        let buffer = html;
        buffer = buffer.replace(/<BR>/g, DriverEscPos.breakLine);
        buffer = buffer.replace(/<B>/g, DriverEscPos.boldOn);
        buffer = buffer.replace(/<\/B>/g, DriverEscPos.boldOff);
        buffer = buffer.replace(/<EM>/g, DriverEscPos.centeredEmphasizedOn);
        buffer = buffer.replace(/<\/EM>/g, DriverEscPos.centeredEmphasizedOff);
        console.log(DriverEscPos.init + DriverEscPos.normalFont + buffer + DriverEscPos.cutePaper);
        return DriverEscPos.init + DriverEscPos.normalFont + buffer + DriverEscPos.cutePaper;
    }



}